export { determineRouteFromConsumerLookup } from './consumerLookupRouter'
export { determineAuthRoute, checkBiometricEligibility } from './authenticationRouter'
export { determinePersistentLoginRoute } from './persistentLoginRouter'
export type { InitialiseNextRoute } from './types'
